
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fan-zone",
      function () {
        return require("private-next-pages/fan-zone/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fan-zone"])
      });
    }
  